import debug from 'debug';
import { APP_NAME } from '../const';

/**
 *
 * @param name
 * @return {debug.IDebugger & { error: debug.IDebugger, test: debug.IDebugger }}
 */
export function getLogger(name) {
  const loggerName = `${APP_NAME}:${name}`;
  const errorName = `${APP_NAME}:error:${name}`;
  const testName = `${APP_NAME}:test:${name}`;

  const logger = debug(loggerName);

  // Error logger
  logger.error = debug(errorName);

  // Test logger
  logger.test = debug(testName);

  return logger;
}
